var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 130
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 0H0V130H130V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 0H8C3.58172 0 0 3.58172 0 8V122C0 126.418 3.58172 130 8 130H122C126.418 130 130 126.418 130 122V8C130 3.58172 126.418 0 122 0Z",
    fill: "#9BFDEB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 36.5C49.2656 36.5 36.5 49.2656 36.5 65C36.5 80.7344 49.2656 93.5 65 93.5C67.6273 93.5 69.75 95.6227 69.75 98.25C69.75 100.877 67.6273 103 65 103C44.0109 103 27 85.9891 27 65C27 44.0109 44.0109 27 65 27C85.9891 27 103 44.0109 103 65V69.75C103 77.6172 96.6172 84 88.75 84C84.4008 84 80.4969 82.0406 77.8844 78.968C74.5 82.0852 69.9727 84 65 84C54.5055 84 46 75.4945 46 65C46 54.5055 54.5055 46 65 46C69.1414 46 72.9711 47.3211 76.0883 49.5773C76.9344 48.8352 78.0328 48.375 79.25 48.375C81.8773 48.375 84 50.4977 84 53.125V65V69.75C84 72.3773 86.1227 74.5 88.75 74.5C91.3773 74.5 93.5 72.3773 93.5 69.75V65C93.5 49.2656 80.7344 36.5 65 36.5ZM74.5 65C74.5 62.4804 73.4991 60.0641 71.7175 58.2825C69.9359 56.5009 67.5196 55.5 65 55.5C62.4804 55.5 60.0641 56.5009 58.2825 58.2825C56.5009 60.0641 55.5 62.4804 55.5 65C55.5 67.5196 56.5009 69.9359 58.2825 71.7175C60.0641 73.4991 62.4804 74.5 65 74.5C67.5196 74.5 69.9359 73.4991 71.7175 71.7175C73.4991 69.9359 74.5 67.5196 74.5 65Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white",
    transform: "translate(27 27)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3224692b52eef7699877e0fcf6a30fbe.svg";
export { ForwardRef as ReactComponent };